import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, BRAND } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 transition-[background-color,box-shadow] duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl shadow-soft-sm" : "bg-white/60 backdrop-blur-md"
      }`}
      data-testid="navbar"
    >
      <nav className="mx-auto max-w-7xl px-5 md:px-8 h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <img
            src={BRAND.logo}
            alt="Divinities Children's Cove logo"
            className="h-14 w-14 rounded-full object-cover ring-2 ring-[#FFD166] transition-transform duration-300 group-hover:-rotate-6"
          />
          <div className="leading-tight">
            <div className="font-head font-700 text-lg text-[#1E293B]">Divinities</div>
            <div className="font-head text-xs tracking-wide text-[#4A90E2] -mt-0.5">Children's Cove</div>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {NAV.map((item) => {
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`font-body font-600 text-sm px-4 py-2 rounded-full transition-colors duration-200 ${
                  active ? "bg-[#4A90E2] text-white" : "text-[#1E293B] hover:bg-[#eaf2fc]"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>

        <button
          onClick={() => navigate("/enroll")}
          data-testid="nav-enroll-btn"
          className="hidden lg:inline-flex items-center font-head font-600 text-sm px-6 py-3 rounded-full bg-[#FFD166] text-[#1E293B] shadow-soft-sm hover:bg-[#f4b83e] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
        >
          Enroll Today
        </button>

        <button
          className="lg:hidden p-2 rounded-full hover:bg-[#eaf2fc]"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-black/5 px-5 pb-6 pt-2" data-testid="mobile-menu">
          <div className="flex flex-col gap-1">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`mobile-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`font-body font-600 px-4 py-3 rounded-2xl ${
                  location.pathname === item.to ? "bg-[#4A90E2] text-white" : "text-[#1E293B] hover:bg-[#eaf2fc]"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/enroll"
              data-testid="mobile-enroll-btn"
              className="mt-2 text-center font-head font-600 px-4 py-3 rounded-full bg-[#FFD166] text-[#1E293B]"
            >
              Enroll Today
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
